import React from 'react';
import styled from 'styled-components';
import Icon from '_Components/Icons/Icon';
import { grayShades, lightenOrDarkenColor } from 'styles/abstracts/colors';
import { round } from 'lodash';

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
`;

const ItemName = styled.div`
  align-text: start;
  font-weight: bold;
`;

const ItemValue = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 0rem;
  font-size: 0.8rem;
  font-weight: normal;
  align-items: center;
  flex-wrap: wrap;
`;

const ValueContainer = styled.span`
  background-color: ${grayShades.g100};
  // color: ${grayShades.g800};
  // color: white;
  font-size: 0.8rem;
  // padding: 2px 5px 1px 5px;
  padding: 4px 5px 3px 5px;
  // border-radius: 7px;
  border-radius: 5px;
  margin-right: 5px;
  margin-bottom: 3px;
  line-height: 1;
  max-height: 19px;
  overflow-y: hidden;
  overflow-x: hidden;
  white-space: nowrap;
  // overflow: hidden;
  &:last-child {
    margin-right: 0px;
  }
`;

const ItemListContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: ${grayShades.g800};
  border: 1px solid transparent;
  border-radius: 12px;
  transition: background-color 0.2s, border 0.2s;
  &:hover {
    border: 1px solid ${grayShades.g800};
    border-radius: 12px;
    background-color: ${lightenOrDarkenColor('#0EC3E3', 16)};

    & ${ItemContainer} ${ItemValue} ${ValueContainer} {
      background-color: ${grayShades.g800};
      color: white;
    }
  }
  &:first-child {
    margin-top: 0.5rem;
  }

  &:last-child {
    margin-bottom: 1.5rem;
  }
`;

type TriggerItemType = {
  item: {
    name: string;
    originalName: string;
    percentage: number;
    value: number;
    impactSat: number;
    differentielSat: number;
  };
};

const TriggerItem = ({ item }: TriggerItemType) => {
  const { name, percentage, value, impactSat, differentielSat } = item;
  const roundedImpactSat = round(impactSat, 2);
  const roundedDifferentielSat = round(differentielSat, 2);
  const icon = 'TRIANGLE';

  return (
    <ItemListContainer>
      <ItemContainer>
        <ItemName>{name}</ItemName>
        <ItemValue>
          <Icon icon={icon} color={grayShades.g800} size={18} />
          <ValueContainer>
            {percentage}
            {' %'}
          </ValueContainer>
          {value === 1 && <ValueContainer>{`${value} mention`}</ValueContainer>}
          {value > 1 && <ValueContainer>{`${value} mentions`}</ValueContainer>}
          {impactSat !== undefined && impactSat !== null && (
            <ValueContainer>{`CSAT ${roundedImpactSat}`}</ValueContainer>
          )}
          {differentielSat !== undefined && differentielSat !== null && (
            <ValueContainer>{`Diff SAT ${roundedDifferentielSat}`}</ValueContainer>
          )}
        </ItemValue>
      </ItemContainer>
    </ItemListContainer>
  );
};

export default TriggerItem;
